import { AppointmentTabEnum } from './appointments_tab_enum';

angular.module('capability-ng-appointments').factory('AppointmentTabEnum', AppointmentTabEnum);

export * from './appointments_tab_enum';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/enums/enums_module.ts